import Divider from './divider';
import './styles/index.scss';
export default Divider;
